import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter.jsx';

const PotatoCharacter = (props) => {
    const primaryColor = "#e0c04a";
    const secondaryColor = "#b2922d";

    const renderPotatoBody = () => (
        <>
            {/* Potato Body - slightly irregular sphere */}
            <mesh castShadow>
                <sphereGeometry args={[0.3, 12, 8]} />
                <meshStandardMaterial color={primaryColor} />
            </mesh>

            {/* Potato "eyes" (the indents) */}
            {[...Array(5)].map((_, i) => {
                const phi = Math.acos(-1 + (2 * i) / 4);
                const theta = Math.sqrt(4 * Math.PI) * phi;
                const x = 0.28 * Math.cos(theta) * Math.sin(phi);
                const y = 0.28 * Math.sin(theta) * Math.sin(phi);
                const z = 0.28 * Math.cos(phi);

                return (
                    <mesh key={i} position={[x, y, z]} rotation={[phi, theta, 0]}>
                        <cylinderGeometry args={[0.03, 0.03, 0.02, 8]} />
                        <meshStandardMaterial color="#856c1e" />
                    </mesh>
                );
            })}
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderPotatoBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default PotatoCharacter;
